<template>
    <div class="form-input form-input-i18n">
        <div class="form-input-header">
            <div class="label">{{ label }}</div>
            <div class="languages">
                <span
                    v-for="lang in $options.languages"
                    :key="lang"
                    :class="{ 'lang-button': true, active: currentLanguage === lang, error: errorHas(lang) }"
                    @click="actionChangeLang(lang)"
                >
                    {{ lang }}
                </span>
            </div>
        </div>
        <div class="form-input-field">
            <input
                type="text"
                v-model="locales[currentLanguage][field]"
                :placeholder="placeholder"
                :maxlength="maxlength === 0 ? false : maxlength"
            />
            <div v-if="note" class="form-input-subtext">{{ note }}</div>
            <div v-if="errorHas(currentLanguage)" class="form-input-error">
                {{ errorMessage(currentLanguage) }}
            </div>
        </div>
    </div>
</template>

<script>
import languages from '@/config/languages';

export default {
    name: 'InputI18n',
    languages,
    props: {
        field: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
        },
        placeholder: {
            type: String,
            required: false,
        },
        locales: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
        },
        currentLanguage: {
            type: String,
            required: false,
        },
        maxlength: {
            type: Number,
            required: false,
            default: 0,
        },
        note: {
            type: String,
            required: false,
        },
    },
    methods: {
        actionChangeLang(currentLang) {
            this.$emit('actionChangeLang', currentLang);
        },
        errorField(lang) {
            return `locales.${ lang }.${ this.field }`;
        },
        errorHas(lang) {
            return this.errors && typeof this.errors[this.errorField(lang)] !== 'undefined' && this.errors[this.errorField(lang)];
        },
        errorMessage(lang) {
            return this.errors[this.errorField(lang)].join('<br/>');
        },
    },
};
</script>
